export const RUNTIME_TILE_MANIFEST_URLS = Object.freeze([
  "/world/generated/vilnius-wide/manifest.json",
  "/world/development/m2/manifest.json",
] as const);
